module.exports = __webpack_public_path__ + "static/media/gallery.830af714.png";